import SwiperJS from '../../../js/vendor/swiper.min.js';
import {SwiperOptions} from 'swiper';

export function AcrStepSlider() {

  let stepSlider: HTMLElement;
  let arrowLeft: HTMLElement;
  let arrowRight: HTMLElement;
  let stepSliderSwiperContainer: HTMLElement;
  let swiperPagination: HTMLElement;
  const arrowLeftSelector = '.swiper-button-prev';
  const arrowRightSelector = '.swiper-button-next';
  const swiperContainerSelector = '.swiper-container';
  const swiperPaginationSelector = '.swiper-pagination';

  const swiperOptions: SwiperOptions = {
    slidesPerView: 1,
    allowTouchMove: true,
    breakpoints: {
      1023: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  };


  function initializeSwiper() {

    new SwiperJS(stepSliderSwiperContainer, {
      ...swiperOptions,
      navigation: {
        nextEl: arrowRight,
        prevEl: arrowLeft,
      },
      pagination: {
        el: swiperPagination,
      },
    });
  }

  // This function initializes the selectors and the data attributes required in other functions
  function initSelectors(element: HTMLElement) {
    stepSlider = element;
    stepSliderSwiperContainer = stepSlider.querySelector(swiperContainerSelector);
    swiperPagination = stepSlider.querySelector(swiperPaginationSelector);
    arrowLeft = stepSlider.querySelector(arrowLeftSelector);
    arrowRight = stepSlider.querySelector(arrowRightSelector);
  }

  function init(element) {
    initSelectors(element);
    initializeSwiper();
  }

  return {
    init: init,
  };
}
